import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Healthcare = () => <VerticalPage config={VERTICALS['healthcare']} />;

export default Healthcare;
